<template>
<div>
	<div v-if="verifying">
		
		<div v-if="!showComponent" class="vertical-center getting-quote">
			<div class="container main-content">
				<div class="row text-center">
					<div class="col-12">
						Verifying... <i class="fas fa-circle-notch fa-spin"></i>
					</div>
				</div>
			</div>
		</div>
		
	</div>
	<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
	<div v-if="!verifying">
		<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
		<div v-if="showComponent" transition="router-anim" class="container main-content">
			<div class="row mb-5">
				<div class="col-12 text-center">
					<h2 class="mb-2">Coincurve Pro</h2>
					<h3 class="mb-5 sub-header">Higher limits.  Lower fees.</h3>
				</div>
			</div>
			<div>
				<div class="row justify-content-center spend-line">
					

					<span class="text-center">I want to spend $
							<input class="amount-input form-control no-border-radius inline" type="number" ref="amount"
							v-model="in_amount" 
							v-bind:class="{'is-invalid': hasError}"
							v-on:keydown.enter="validateInputForm"
							/>

						CAD to buy

						<select id="cryptocurrency" v-model="cryptocurrency" class="form-control form-control-lg crypto-select mt-3">
							<option value="BTC">Bitcoin (BTC)</option>
							<option value="BCH">Bitcoin Cash (BCH)</option>
							<option value="LTC">Litecoin (LTC)</option>
							<option value="ETH">Ethereum (ETH)</option>
						<template v-if="!$gstate.isProd()">
							<option value="LTCT">Litecoin Test</option>	
						</template>
							
						</select>
					</span>
					
				</div>
				
				<div class="row mt-5 mb-5">
					<div class="col-12 text-center">
						<small class="error" v-if="hasError">{{ errorMessage }}</small>
					</div>
				</div>
						
				<div class="row mt-5">
					<div class="col-12 text-center">
						<a href="#" id="address-input-next" class="btn next-btn" v-on:click.prevent="validateInputForm">NEXT</a>
					</div>
				</div>
				
				<div class="row justify-content-center">
					<p class="details-text mt-5 text-center">Interac E-transfer only. Increased daily limit of $2,500 CAD. Reduced fee of {{ $gstate.getEtransferFeePro() }}%.</p>
				</div>
				
			</div>
		</div>
		</transition>
		<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
		<div v-if="!showComponent" class="vertical-center getting-quote">
			<div class="container main-content">
				<div class="row text-center">
					<div class="col-12">
						<template v-if="!hasError">
							Getting quote... <i class="fas fa-circle-notch fa-spin"></i>
						</template>
						<template v-else>
							<p>{{ errorMessage }}</p>
							<p class="mt-4">
								<a :href="$gstate.getSiteURL()" id="address-input-next" class="btn next-btn">TRY AGAIN</a>
							</p>
						</template>
					</div>
				</div>
			</div>
		</div>
		</transition>
	</div>
	</transition>
</div>
</template>

<script>

import { eventBus } from './../main'
import { log } from 'util';

export default {
	data() {
		return {
			showComponent: false,
			in_amount: 100,
			hasError: false,
			errorMessage: '',
			cryptocurrency: 'BTC',	// default option
			paymentMethod: 'ETRANSFER',	// default option
			paymentMethodSubtype: '',	// default option
			fiatCurrency: 'CAD',	// default option
			failedCount: 0,
			timeout: null,
			verifying: false,
			customerHash: ''
		}
	},
	mounted() {

		this.$emit('setLeaveNotification', false);
		this.$emit('setRateHoldTimer', false);
		
	},
	created(){

		this.$gstate.init();

		var amount =			this.$route.params.amount;
		var method =			this.$route.params.method;
		var cryptocurrency =	this.$route.params.cryptocurrency;
		var txnType =			this.$route.params.type;
		var currency =			this.$route.params.currency;
		var subtype =			this.$route.params.subtype;
		
		this.$gstate.setActiveFiatCurrency(currency);
		this.$gstate.setActiveCryptoCurrency(cryptocurrency);
		this.$gstate.setPaymentMethodSubtype(subtype);

		// force "BUY" by default if not specified in URL
		if(txnType == undefined){
			txnType = 'BUY';
		}

		if(currency == undefined){
			currency = 'CAD';
		}
		
		this.$gstate.setTxnType(txnType.toUpperCase());
		
		if(this.$gstate.isProFlow()){

			this.customerHash = this.$route.params.customerHash;
			
			if(this.customerHash != null){

				this.verifying = true;
				this.checkValidHash();

			} else {
				this.$gstate.redirectHome('', 200, 'no pro hash found');
			}

		} else {

			if(isNaN(amount)){
				this.hasError = true;
				this.errorMessage = "Value must be a number.";
			}

			if(amount < this.$gstate.getMinAmount(this.$gstate.getTxnType(), method)){
				this.hasError = true;
				this.errorMessage = 'Amount must be greater than '+ this.$gstate.getMinAmount(this.$gstate.getTxnType(), method) +'.';
			}

			if(amount > this.$gstate.getMaxAmount(this.$gstate.getTxnType(), method)){
				this.hasError = true;
				this.errorMessage = 'Amount must be less than '+ this.$gstate.getMaxAmount(this.$gstate.getTxnType(), method) +'.';
			}

			if(method == 'GIFTCARD' && subtype == null){
				this.hasError = true;
				this.errorMessage = 'Gift card must be selected.';
			}

			if(this.hasError){
				return;
			}

			eventBus.$on('nextScreen', this.getPrice);

			if(amount != null && method != null && cryptocurrency != null && txnType != null && currency != null){

				this.in_amount = amount;
				this.paymentMethod = method;
				this.cryptocurrency = cryptocurrency;
				this.txnType = txnType.toUpperCase();
				this.fiatCurrency = currency;
				this.paymentMethodSubtype = subtype;
				
				if(method == 'CREDITCARD'){
					
					var data = {
						fiatAmount: this.in_amount,
						cryptoCurrency: this.cryptocurrency,
						fiatCurrency: this.fiatCurrency,
					};

					this.$gstate.saveFlowState(data);
					
					this.$router.push('/credit-card-quote');
					
					return;
					
				} else {
					this.getPrice();	
				}

			} else {
				this.$gstate.redirectHome('', 200, 'params null');
				
			}


		}

	},
	beforeDestroy(){
		if(!this.$gstate.isProFlow()){
			eventBus.$off('nextScreen', this.getPrice);
		}
	},
	methods: {
		showProForm: function (){

			//default
			this.cryptocurrency = 'BTC';
			if(this.$gstate.isDev()){
				this.cryptocurrency = 'LTCT';
			}

			this.showComponent = true;
		},
		validateInputForm: function(){

			this.hasError = false;
			if (this.in_amount < 100) {
				this.errorMessage = 'Amount must be greater than $100.';
				this.hasError = true;
				return;
			}

			if (this.in_amount > 3000) {
				this.errorMessage = 'Amount must be less than $3,000.';
				this.hasError = true;
				return;
			}

			if(this.paymentMethod != 'ETRANSFER'){
				this.errorMessage = 'Payment method must be Interac E-Transfer'
				this.hasError = true;
				return;
			}

			this.showComponent = false;
			this.failedCount = 0;

			this.getPrice();
		},
		getPrice: function() {
			this.hasError = false;

			if(!this.$gstate.isValidPaymentMethod(this.paymentMethod)){
				// technically no screen to show these errors on so just redirect to home
				this.errorMessage = 'Payment method not found.'
				this.hasError = true;
				this.$gstate.redirectHome('', 200, this.errorMessage);
				return;
			}

			// validate input amount
			if(this.txnType == 'SPEND' && !this.$gstate.getPaymentMethodAmounts(this.paymentMethod).includes(parseInt(this.in_amount))){
				this.errorMessage = 'Payment amount not valid for this gift card.'
				this.hasError = true;
				this.$gstate.redirectHome('', 100, this.errorMessage);
				return;
			}

			this.$gstate.log("processing quote...");

			var urlstr = this.$gstate.getApiBaseURL() + '/quoterequest';

			var browserResolution = window.screen.width + "x" + window.screen.height;

			var data = {
					fiatAmount: this.in_amount,
					fiatCurrency: this.fiatCurrency,
					cryptoCurrency: this.cryptocurrency,
					paymentMethod: this.paymentMethod,
					txnType: this.txnType,
					browserResolution: browserResolution,
					country: this.$gstate.getActiveCountry()
				};

			if(this.$gstate.getTxnType() == 'BUY'){
				data.fiatAmount = this.in_amount;
				data.cryptoAmount = 0;
			} else if(this.$gstate.getTxnType() == 'SELL'){

				if(this.paymentMethod == 'GIFTCARD'){
					data.fiatAmount = this.in_amount;
					data.paymentMethodSubtype = this.paymentMethodSubtype;
					data.cryptoAmount = 0;
				} else {
					data.fiatAmount = 0;
					data.cryptoAmount = this.in_amount;
				}

			}

			if(this.$gstate.isProFlow()){
				data.vipTag = this.customerHash;
				data.txnType = 'BUY';
				this.txnType = data.txnType;
			}

			this.axios.post(urlstr, data, this.$gstate.getAxiosHeaders())
				.then(response => {

					this.$gstate.log(response);
					this.$gstate.saveFlowStateAndProceed(response.data, this);

				})
				.catch(error => {
					this.$gstate.log(error.response);

					// try again in 5 seconds
					this.$gstate.log("price quote failed");

					if(error.response.data.error != undefined && error.response.data.error.msg != undefined){
						this.errorMessage = error.response.data.error.msg;
						this.hasError = true;

						if(this.$gstate.isProFlow()){
							this.showComponent = true;
						}

						return;
					}

					this.timeout = setTimeout(() => {
						
						this.$gstate.log("trying again...");

						if(this.failedCount >= 3){

							if(this.$gstate.isProFlow()){
								clearTimeout(this.timeout);
								this.showComponent = true;
							}

							this.hasError = true;
							this.errorMessage = "Service Temporarily Unavailable. Please try again later.";

							
						} else {
							this.failedCount++;
							this.getPrice();
						}

						
					}, 2000);
					
				});
		},
		checkValidHash(){

			var urlstr = this.$gstate.getApiBaseRootURL() + '/vipcheck';
			this.axios.post(urlstr, { vipTag: this.customerHash }, this.$gstate.getAxiosHeaders())
				.then(response => {
					
					if(response.data == false){
						this.$gstate.redirectHome('', 200, 'not vip hash');
					} else {
						this.verifying = false;
						this.showProForm();	
					}
					
				})
				// eslint-disable-next-line
				.catch(error => {
					this.$gstate.redirectHome('', 200, 'failed hash request');
				});
		}
	}
}

</script>